import styled from 'styled-components';
import {POPUP_MOBILE_PADDING_INLINE, POPUP_PADDING_INLINE} from '../../../pages/team/about/About.css';
import {getGridArea} from '../../../functions/cssFenctions';
import {DARK_GRAY2, DEFAULT_COLOR, mobileMedia, scrollbar} from '../../../globalVariables/GlobalVariables';
import {textWrap, wrapInput} from '../../../component/input/basicInput/BasicInput.css';
import * as input from '../../../component/classes/input';
import {icon} from '../../../component/input/inputList/InputList.css';
import zIndex from '../../../globalVariables/zIndex';
import {alignStretch, dFlex, dFlexColumn, dInlineFlex, flexNoWrap, flexWrap, justifyBetween, justifyEnd} from '../../../globalVariables/GlobalFlex';
import {popUpContent} from '../../../component/popUp/PopUp.css';
import { wrap } from '../../../component/textEditor/TextEditor.css';
import { popUpTop } from '../../../component/newPopup/topPopup/TopPopup.css';
import { tooltip } from '../../../component/tooltip/tooltipAbsolute/TooltipAbsolute.css';
import { charNum } from '../../../component/input/textareaInput/TextareaInput.css';
import { icon as inputIcon } from '../../../component/classes/input';

export const popUp= styled.div`
    ${popUpTop} {
        min-height: 60px;
    }
    ${popUpContent}{
        overflow-y: auto;
        ${mobileMedia}{
            height: calc(100% - 180px);
        }
    }
`;
export const header = styled.div`
    ${dFlex}
    ${justifyBetween}
    ${alignStretch}
    width: calc(100% - 75px);
    height: 60px;
    padding-block: 20px;
    margin: -60px 50px auto 50px;
    z-index: ${zIndex.baseRaised};
    font-size: 16px;
    ${mobileMedia}{
        margin-top: 0;
    }
`;
export const container=styled.div<{ formType?: string }>` 
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px ${POPUP_PADDING_INLINE};
    display: grid;
    grid-template-areas: "title video"
                         "summary summary"
                        "description description"
                        "distributions page";
    column-gap: 4%;
    row-gap: 15px;
    grid-template-columns: 48% 48%;
    ${getGridArea(['title','video','distributions','page'])}
    ${mobileMedia}{
            ${dFlexColumn}
            padding-inline:${POPUP_MOBILE_PADDING_INLINE};
            margin-inline: 0;
            >div{
                margin-top: 10px;
            }
    }
    .message {     
        ${dFlexColumn}
        height: 150px;
        ${wrapInput}, textarea, div[class*=container] {
            height: 100%;
        }
    }
`;
export const textEditorWrapper = styled.div<{ charText?: string }>`
    grid-area: summary;
    position: relative;
    ${dFlexColumn}
    gap: 10px;
    padding: var(--space-lg);
    border-radius: var(--space-md, 12px);
    background: var(--primitive-gray-100);
    ${wrap} {
        background: var(--TA-color-bg-base);
    }
    ${inputIcon} {
        display: none;
    }
    ${charNum} {
        padding-inline-start: 25px;
        font-size: var(--font-size-caption);
        &:after {
            content: ${p => p.charText};
            padding-inline-start: 4px;
        }
    }
    textarea {
        height: 100%;
        border: 1px solid var(--TA-color-border-disabled);
        border-radius: 10px;
        background: var(--TA-color-bg-base);
        padding: var(--space-xl);
        font-size: var(--font-size-body-small);
        font-weight: normal;
    }
    ${textWrap} {
        display: none;
    }
`;
export const descriptionWrapper = styled(textEditorWrapper)`
    grid-area: description;
    ${wrap} .ql-container {
        height: 260px;
    }
`;
export const textEditorLabel = styled.div`
    color: var(--TL-color-text-default);
    font-size: 16px;
     ${tooltip} {
        width: 13px;
        height: 13px;
        padding: 0;
        background-size: 13px 8px;
        border-radius: 50%;
        background-position: center;
        // Hardcoded color - no matching token in @tickchak/react-share
        background-color: #DD2F21;
        position: absolute;
        inset-inline-end: var(--space-lg);
        top: var(--space-lg);
    }
`;

export const distributions = styled.div``;
export const howToDisplay = styled.div`
    grid-area: howToDisplay;
    ${dInlineFlex}
`;
export const roleSelectInput = styled(input.container)`
    padding-bottom: 0;
    margin-top: -8px;
    ${icon} {
        width: 0;
    }
`;
export const rolesContainer = styled.div`
        position: absolute;
        inset-inline-end: 20px;
        top: 15px;
        ${dInlineFlex}
        max-width: calc(100% - 120px);
        overflow-x: auto;
        overflow-y: hidden;
        ${flexNoWrap}
        ${scrollbar}
`;
export const selectedPageContainer = styled(rolesContainer)`
    max-width: calc(100% - 95px);
    top: 20px;
`;
export const bottom = styled.div`
    ${dFlex}
    ${justifyEnd}
    padding: 3%;
    border-top: 1px solid ${DARK_GRAY2};
    div:first-child{
        margin-inline-end: 15px;
    }
`;

export const selectedPageType = styled.div`
    padding: 3px 9px 5px 8px;
    border-radius: 55px;
    border: 0.5px solid ${DEFAULT_COLOR};
    cursor: pointer;
    font-size: 10px;
    margin-inline: 2px;
    min-width: fit-content
`;